var map = {
	"./icon_facebook": 998,
	"./icon_facebook.js": 998,
	"./icon_instagram": 999,
	"./icon_instagram.js": 999,
	"./icon_linkedin": 1000,
	"./icon_linkedin.js": 1000,
	"./icon_x": 1001,
	"./icon_x.js": 1001,
	"./icon_youtube": 1002,
	"./icon_youtube.js": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1008;